/**
 * lop-texto-productos-scroll-lock.js
 * Bloquea scroll horizontal por rueda / trackpad sobre el viewport del carrusel.
 * El carril sigue usando scrollLeft vía flechas (featured-collection-carousel.js).
 * No hay drag manual ni comportamiento tipo “smooth scroll mouse”.
 */
(function () {
  'use strict';

  function lockViewport(viewport) {
    if (!viewport || viewport.dataset.lopScrollLockInit === 'true') return;
    viewport.dataset.lopScrollLockInit = 'true';

    viewport.addEventListener(
      'wheel',
      function (e) {
        var dx = Math.abs(e.deltaX);
        var dy = Math.abs(e.deltaY);
        if (e.shiftKey || dx >= dy) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.LOP-texto-productos .theme-scroll--inner').forEach(lockViewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      init(event.target);
    }
  });
})();
